import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'primereact/resources/themes/saga-blue/theme.css';  // Theme
import 'primereact/resources/primereact.min.css';          // Core CSS
import 'primeicons/primeicons.css';                        // Icons
import 'primeflex/primeflex.css';                          // Flex utilities (optional)
import './styles/primereact-new-gui.css';                  // Scoped token retone for .new-gui-datatable (no-op elsewhere)

const isResizeObserverMessage = (message: string) =>
  message.includes('ResizeObserver loop') ||
  message.includes('ResizeObserver loop limit exceeded') ||
  message.includes('ResizeObserver loop completed with undelivered notifications');

const suppressResizeObserverWarning = (event: ErrorEvent) => {
  const message = (typeof event?.message === 'string' ? event.message : '') ||
    (event?.error?.message && String(event.error.message)) || '';
  if (isResizeObserverMessage(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }
  return false;
};

const originalConsoleError = console.error.bind(console);
const originalConsoleWarn = console.warn.bind(console);
const suppressConsoleResizeObserver = (...args: unknown[]) => {
  const first = args[0];
  if (typeof first === 'string' && isResizeObserverMessage(first)) {
    return;
  }
  if (first instanceof Error && isResizeObserverMessage(first.message)) {
    return;
  }
  originalConsoleError(...args);
};
const suppressConsoleWarnResizeObserver = (...args: unknown[]) => {
  const first = args[0];
  if (typeof first === 'string' && isResizeObserverMessage(first)) {
    return;
  }
  originalConsoleWarn(...args);
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event: ErrorEvent) => {
    if (suppressResizeObserverWarning(event)) return;
  }, true);
  window.onerror = (message, _source, _lineno, _colno, error) => {
    const msg = typeof message === 'string' ? message : (error?.message && String(error.message)) || '';
    if (isResizeObserverMessage(msg)) return true;
    return false;
  };
  // Suppress CRA dev overlay warning for ResizeObserver loop.
  // eslint-disable-next-line no-console
  console.error = suppressConsoleResizeObserver as typeof console.error;
  // eslint-disable-next-line no-console
  console.warn = suppressConsoleWarnResizeObserver as typeof console.warn;

  const OriginalRO = window.ResizeObserver;
  if (OriginalRO) {
    window.ResizeObserver = class extends OriginalRO {
      constructor(callback: ResizeObserverCallback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
   <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
